import{REQUEST_RESET_PASSWORD,ERROR_RESET_PASSWORD,RECEIVE_RESET_PASSWORD}from"../constants";/**
 * Creates the dispatched REQUEST_RESET_PASSWORD action object.
 * @param {string} email The email address for the reset password request.
 * @returns {Object} The dispatched action object.
 */export var requestResetPassword=function requestResetPassword(email){return{type:REQUEST_RESET_PASSWORD,email:email};};/**
 * Creates the dispatched RECEIVE_RESET_PASSWORD action object.
 * @param {string} email The email address for the reset password request.
 * @returns {Object} The dispatched action object.
 */export var receiveResetPassword=function receiveResetPassword(email){return{type:RECEIVE_RESET_PASSWORD,email:email};};/**
 * Creates the dispatched ERROR_RESET_PASSWORD action object.
 * @param {string} email The email address for the reset password request.
 * @param {Object} error A pipeline error.
 * @returns {Object} The dispatched action object.
 */export var errorResetPassword=function errorResetPassword(email,error){return{type:ERROR_RESET_PASSWORD,email:email,error:error};};